import React, { PureComponent } from "react";

class Privacy extends PureComponent {
  state = {};
  render() {
    return (
      <>
        <section className="bg-half bg-light d-table w-100 d-print-none">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12 text-center">
                <div className="page-next-level">
                  <h4 className="title"> Privacy Policy</h4>
                  <ul className="list-unstyled mt-4">
                    <li className="list-inline-item h6 date text-muted">
                      {" "}
                      <span className="text-dark">Last Revised :</span> 23th
                      Sep, 2019
                    </li>
                  </ul>
                  <div className="page-next">
                    <nav aria-label="breadcrumb" className="d-inline-block">
                      <ul className="breadcrumb bg-white rounded shadow mb-0">
                        <li className="breadcrumb-item">
                          <a href="index.html">Hostarena</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Privacy
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="position-relative">
          <div className="shape overflow-hidden text-white">
            <svg
              viewBox="0 0 2880 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <div className="card shadow rounded border-0">
                  <div className="card-body">
                    <h5 className="card-title">
                      Privacy Policy for Hostarena LTD :
                    </h5>
                    <p className="text-muted">
                      At Hostarena, accessible from https://hostarena.org, one
                      of our main priorities is the privacy of our visitors.
                      This Privacy Policy document contains types of information
                      that is collected and recorded by Hostarena and how we use
                      it.
                    </p>
                    <p className="text-muted">
                      If you have additional questions or require more
                      information about our Privacy Policy, do not hesitate to
                      contact us.
                    </p>
                    <p className="text-muted">
                      This Privacy Policy applies only to our online activities
                      and is valid for visitors to our website with regards to
                      the information that they shared and/or collect in
                      Hostarena. This policy is not applicable to any
                      information collected offline or via channels other than
                      this website. Our Privacy Policy was created with the help
                      of the TermsFeed Privacy Policy Generator.
                    </p>
                    <h5 className="card-title">Consent :</h5>
                    <p className="text-muted">
                      - By using our website, you hereby consent to our Privacy
                      Policy and agree to its terms.
                    </p>
                    <h5 className="card-title">Information we collect :</h5>
                    <p className="text-muted">
                      The personal information that you are asked to provide,
                      and the reasons why you are asked to provide it, will be
                      made clear to you at the point we ask you to provide your
                      personal information.
                    </p>
                    <p className="text-muted">
                      If you contact us directly, we may receive additional
                      information about you such as your name, email address,
                      phone number, the contents of the message and/or
                      attachments you may send us, and any other information you
                      may choose to provide.
                    </p>
                    <p className="text-muted">
                      When you register for an Account, we may ask for your
                      contact information, including items such as name, company
                      name, address, email address, and telephone number.
                    </p>
                    <h5 className="card-title">
                      How we use your information :
                    </h5>
                    <p className="text-muted">
                      We use the information we collect in various ways,
                      including to:
                    </p>
                    <ul className="text-muted">
                      <li>
                        By using our website, you hereby consent to our Privacy
                        Policy and agree to its terms.
                      </li>
                      <li>Improve, personalize, and expand our website</li>
                      <li>Understand and analyze how you use our website</li>
                      <li>
                        Develop new products, services, features, and
                        functionality
                      </li>
                      <li>
                        Communicate with you, either directly or through one of
                        our partners, including for customer service, to provide
                        you with updates and other information relating to the
                        website, and for marketing and promotional purposes
                      </li>
                      <li>Send you emails</li>
                      <li>Find and prevent fraud</li>
                      <li>Log Files</li>
                    </ul>
                    <p className="text-muted">
                      Hostarena follows a standard procedure of using log files.
                      These files log visitors when they visit websites. All
                      hosting companies do this and a part of hosting services'
                      analytics. The information collected by log files include
                      internet protocol (IP) addresses, browser type, Internet
                      Service Provider (ISP), date and time stamp,
                      referring/exit pages, and possibly the number of clicks.
                      These are not linked to any information that is personally
                      identifiable. The purpose of the information is for
                      analyzing trends, administering the site, tracking users'
                      movement on the website, and gathering demographic
                      information.
                    </p>
                    <h5 className="card-title">
                      Advertising Partners Privacy Policies :
                    </h5>
                    <p className="text-muted">
                      You may consult this list to find the Privacy Policy for
                      each of the advertising partners of Hostarena.
                    </p>
                    <p className="text-muted">
                      Third-party ad servers or ad networks uses technologies
                      like cookies, JavaScript, or Web Beacons that are used in
                      their respective advertisements and links that appear on
                      Hostarena, which are sent directly to users' browser. They
                      automatically receive your IP address when this occurs.
                      These technologies are used to measure the effectiveness
                      of their advertising campaigns and/or to personalize the
                      advertising content that you see on websites that you
                      visit.
                    </p>
                    <p className="text-muted">
                      Note that Hostarena has no access to or control over these
                      cookies that are used by third-party advertisers.
                    </p>
                    <h5 className="card-title">
                      Third Party Privacy Policies :
                    </h5>
                    <p className="text-muted"></p>
                    Hostarena's Privacy Policy does not apply to other
                    advertisers or websites. Thus, we are advising you to
                    consult the respective Privacy Policies of these third-party
                    ad servers for more detailed information. It may include
                    their practices and instructions about how to opt-out of
                    certain options.
                    <p className="text-muted">
                      You can choose to disable cookies through your individual
                      browser options. To know more detailed information about
                      cookie management with specific web browsers, it can be
                      found at the browsers' respective websites.
                    </p>
                    <h5 className="card-title">
                      CCPA Privacy Rights (Do Not Sell My Personal Information)
                      :
                    </h5>
                    <p className="text-muted">
                      Under the CCPA, among other rights, California consumers
                      have the right to:
                    </p>
                    <p className="text-muted">
                      Request that a business that collects a consumer's
                      personal data disclose the categories and specific pieces
                      of personal data that a business has collected about
                      consumers.
                    </p>
                    <p className="text-muted">
                      Request that a business delete any personal data about the
                      consumer that a business has collected.
                    </p>
                    <p className="text-muted">
                      Request that a business that sells a consumer's personal
                      data, not sell the consumer's personal data.
                    </p>
                    <p className="text-muted">
                      If you make a request, we have one month to respond to
                      you. If you would like to exercise any of these rights,
                      please contact us.
                    </p>
                    <h5 className="card-title">
                      GDPR Data Protection Rights :
                    </h5>
                    <p className="text-muted">
                      We would like to make sure you are fully aware of all of
                      your data protection rights. Every user is entitled to the
                      following:
                    </p>
                    <ul className="text-muted">
                      <li>
                        The right to access – You have the right to request
                        copies of your personal data. We may charge you a small
                        fee for this service.
                      </li>
                      <li>
                        The right to rectification – You have the right to
                        request that we correct any information you believe is
                        inaccurate. You also have the right to request that we
                        complete the information you believe is incomplete.
                      </li>
                      <li>
                        The right to erasure – You have the right to request
                        that we erase your personal data, under certain
                        conditions.
                      </li>
                      <li>
                        The right to restrict processing – You have the right to
                        request that we restrict the processing of your personal
                        data, under certain conditions.
                      </li>

                      <li>
                        The right to object to processing – You have the right
                        to object to our processing of your personal data, under
                        certain conditions.
                      </li>

                      <li>
                        The right to data portability – You have the right to
                        request that we transfer the data that we have collected
                        to another organization, or directly to you, under
                        certain conditions.
                      </li>

                      <li>
                        If you make a request, we have one month to respond to
                        you. If you would like to exercise any of these rights,
                        please contact us.
                      </li>
                    </ul>
                    <h5 className="card-title">Children's Information :</h5>
                    <p className="text-muted">
                      Another part of our priority is adding protection for
                      children while using the internet. We encourage parents
                      and guardians to observe, participate in, and/or monitor
                      and guide their online activity.
                    </p>
                    <p className="text-muted">
                      Hostarena does not knowingly collect any Personal
                      Identifiable Information from children under the age of
                      13. If you think that your child provided this kind of
                      information on our website, we strongly encourage you to
                      contact us immediately and we will do our best efforts to
                      promptly remove such information from our records.
                    </p>
                    <a
                      href="javascript:window.print()"
                      className="btn btn-soft-primary d-print-none"
                    >
                      Print
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Privacy;
